import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "gfmp_kandake_token";
const USER_KEY = "gfmp_kandake_user";

export function getStoredToken() {
  return typeof window !== "undefined" ? window.localStorage.getItem(TOKEN_KEY) : null;
}
export function setStoredToken(token) {
  if (token) window.localStorage.setItem(TOKEN_KEY, token);
  else window.localStorage.removeItem(TOKEN_KEY);
}
export function getStoredUser() {
  try {
    const raw = window.localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch { return null; }
}
export function setStoredUser(user) {
  if (user) window.localStorage.setItem(USER_KEY, JSON.stringify(user));
  else window.localStorage.removeItem(USER_KEY);
}

export const api = axios.create({ baseURL: API_BASE, timeout: 30000 });

// Public, unauthenticated API surface (GFMP Sync Catalogue + public inquiry).
// Has NO request interceptor (so a stale token can never leak onto the
// public endpoints) and NO response 401-redirect (so a public page never
// bounces a visitor to /login if the backend is briefly unhappy).
export const publicApi = axios.create({ baseURL: API_BASE, timeout: 30000 });

api.interceptors.request.use((config) => {
  const t = getStoredToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      setStoredToken(null);
      setStoredUser(null);
      if (typeof window !== "undefined" && window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  }
);

export function buildAudioUrl(trackId) {
  const t = getStoredToken();
  return `${API_BASE}/tracks/${trackId}/audio?auth=${encodeURIComponent(t || "")}`;
}

export function buildDemoAudioUrl(demoId) {
  const t = getStoredToken();
  return `${API_BASE}/demos/${demoId}/audio?auth=${encodeURIComponent(t || "")}`;
}

export function buildDocumentFileUrl(docId) {
  const t = getStoredToken();
  return `${API_BASE}/documents/${docId}/file?auth=${encodeURIComponent(t || "")}`;
}

export function errMsg(e, fallback = "Something went wrong") {
  return e?.response?.data?.detail || e?.message || fallback;
}
